
import Review from './Review';


function App() {
    return(
      <main className=' w-full flex justify-center mt-16'>
        <section className=' w-full'>
          <div className=' text-center my-3 text-2xl'>
            <h2 className=' font-bold'>Our Reviews</h2>
          
          </div>
          <Review/>
        </section>
      </main>
    )
  }
  

export default App;
